import { AxiosError } from 'axios';
import { IErrorResponse } from '@sweatpals/shared';

export const getReponseDataFromAxiosError = (err: Error | AxiosError): IErrorResponse | null => {
	if ((err as AxiosError).response) {
		return (err as AxiosError).response?.data as IErrorResponse;
	}

	return null;
};
